import { reducerWithInitialState } from "typescript-fsa-reducers";
import { State } from "./facebook-user.types";
import * as actions from "./facebook-user.actions";

export const initialState: Readonly<State> = {
  facebookUser: undefined,
  isFacebookUserLoading: false,
};

export default reducerWithInitialState(initialState)
  .case(actions.resetFacebookUser, () => ({ ...initialState }))
  .case(actions.isFacebookUserLoading, (state, { isFacebookUserLoading }) => ({
    ...state,
    isFacebookUserLoading,
  }))
  .case(actions.facebookUser, (state, { facebookUser }) => ({
    ...state,
    facebookUser,
  }))
  .build();
